var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIvstTdy01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_6780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9258 30.3743V4.49933C19.9257 4.29572 19.8703 4.09597 19.7656 3.92137C19.6608 3.74676 19.5107 3.60385 19.3311 3.50786C19.1516 3.41188 18.9494 3.36642 18.746 3.37634C18.5426 3.38625 18.3458 3.45117 18.1764 3.56417L6.92641 11.0637C6.7721 11.1667 6.64564 11.3062 6.5583 11.4698C6.47095 11.6335 6.42543 11.8162 6.42578 12.0017V30.3743",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9258 12.375H30.0508C30.3491 12.375 30.6353 12.4935 30.8463 12.7045C31.0573 12.9155 31.1758 13.2016 31.1758 13.5V30.375",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05078 30.375H34.5508",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4258 15.75V18",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 15.75V18",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9258 23.625V25.875",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4258 23.625V25.875",
    stroke: "#4C5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_6780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIvstTdy01);
export default __webpack_public_path__ + "static/media/icon-ivst-tdy-01.d4c7a78c347ecf67c0bb6e52263b0636.svg";
export { ForwardRef as ReactComponent };